__turbopack_context__.v({
  "column": "EventListItemLoading-module-scss-module__145cwa__column",
  "content": "EventListItemLoading-module-scss-module__145cwa__content",
  "contentLine": "EventListItemLoading-module-scss-module__145cwa__contentLine",
  "loadingContainer": "EventListItemLoading-module-scss-module__145cwa__loadingContainer",
  "pulse": "EventListItemLoading-module-scss-module__145cwa__pulse",
  "row": "EventListItemLoading-module-scss-module__145cwa__row",
  "title": "EventListItemLoading-module-scss-module__145cwa__title",
});
